module.exports = __webpack_public_path__ + "static/client5-69fd3dfe427b9aedf7c1e0e50bd9c4c4.png";